import { useQuery, useQueryClient } from "@tanstack/react-query";

import type { ISetupPromptsResponse } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/types";
import { DefaultFetchService } from "app/services/fetchService";

const setupPromptsQueryKey = (domain: string, cultureName: string, topics: string[], promptsPerTopic: number) => [
    "llm-tracker",
    "generate prompts",
    domain,
    cultureName,
    topics ?? [],
    promptsPerTopic,
];

export const useSetupPrompts = (
    domain: string,
    cultureName: string,
    topics: string[],
    promptsPerTopic: number,
    options?: { enabled?: boolean },
) => {
    const queryClient = useQueryClient();
    const queryKey = setupPromptsQueryKey(domain, cultureName, topics, promptsPerTopic);

    const query = useQuery<ISetupPromptsResponse>({
        queryKey,
        queryFn: async ({ signal }) => {
            const fetchService = DefaultFetchService.getInstance();
            const response = await fetchService.post(
                "/api/aiTracker/prompts",
                {
                    domain,
                    cultureName,
                    topics,
                    promptsPerTopic,
                },
                { cancellation: signal },
            );

            return response as ISetupPromptsResponse;
        },
        retry: 1,
        gcTime: 0,
        staleTime: 0,
        ...options,
    });

    const cancelQuery = () => queryClient.cancelQueries({ queryKey });

    return { ...query, cancelQuery };
};
